document.addEventListener('DOMContentLoaded', () => {

    let imagesSliders = document.querySelectorAll('.images-sliders');
    if(imagesSliders){
        imagesSliders.forEach((item)=>{
            new Swiper(item, {
                rewind: true,
                effect: "fade",
                fadeEffect: {
                    "crossFade": true
                },
                pagination: {
                    el: ".pagination-images",
                    clickable: true,
                },
                navigation: {
                    nextEl: ".sw-but-img-next",
                    prevEl: ".sw-but-img-prev",
                },
            });
        });
    }

    let swiperTop = document.querySelectorAll('.swiper-top');
    if(swiperTop){
        swiperTop.forEach((item)=>{
            new Swiper(item, {
                loop: true,
                effect: "fade",
                speed: 1000,
                fadeEffect: {
                    "crossFade": true
                },
                autoplay: {
                    delay: 80000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                navigation: {
                    nextEl: ".sw-but-img-next",
                    prevEl: ".sw-but-img-prev",
                }
            });
            let linkSwiper = document.querySelectorAll(".swiper-pagination-bullet");
            linkSwiper.forEach((nav)=>{
                nav.addEventListener("mouseover",()=>{
                    nav.click();
                });
            });
        });
    }

    let introMapBlock = document.querySelectorAll('.intro-maps-block');
    let introSlider = document.querySelectorAll('.intro-slider');
    if(introSlider){
        introSlider = new Swiper('.intro-slider', {
            /*Optional parameters*/
            loop: false,
            effect: "fade",
            autoHeight: true,
            fadeEffect: {
                "crossFade": true
            },
            breakpoints: {
                600: {
                    autoHeight: false,
                    autoplay: {
                        delay: 8000,
                    },
                }
            }
        });
        introMapBlock.forEach(function(hB,hBc) {
            let hNav = hB.querySelectorAll('.map-item');
            console.log(hNav);
            hNav.forEach(function(h_nav) {
                let navCount = h_nav.dataset.nav;
                h_nav.addEventListener('click', function(e){
                    e.preventDefault();
                    if(introMapBlock.length > 1){
                        introSlider[hBc].slideTo(navCount, 1000);
                    } else {
                        introSlider.slideTo(navCount, 1000);
                    }
                    hNav.forEach(function(h_nav) {
                        h_nav.classList.remove('active');
                    });
                    this.classList.add('active');
                });
                if(introMapBlock.length > 1){
                    introSlider[hBc].on('slideChange', function () {
                        hNav.forEach(function(h_nav) {
                            let navC = h_nav.dataset.nav;
                            h_nav.classList.remove('active');
                            if(introSlider[hBc].realIndex == navC){
                                h_nav.classList.add('active');
                            }
                        });
                    });
                } else {
                    let navIn = 0;
                    introSlider.on('slideChange', function () {
                        hNav.forEach(function(h_nav) {
                            let navC = h_nav.dataset.nav;
                            h_nav.classList.remove('active');
                            if(introSlider.realIndex == navC && navIn != 0){
                                h_nav.classList.add('active');
                            }
                            navIn++;
                        });
                    });
                }
            });
        });
    }

    let sliderSlide = document.querySelectorAll('.slide-slider');
    if(sliderSlide){
        sliderSlide.forEach((item)=> {
            new Swiper(item, {
                loop: true,
                effect: "fade",
                fadeEffect: {
                    "crossFade": true
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                    renderBullet: function (index, className) {
                    return '<span class="' + className + '">' + (index + 1) + "</span>";
                    },
                }
            });
        });
    }

    let gallerySlider = document.querySelectorAll('.gallery-slider');
    if(gallerySlider){
        gallerySlider.forEach((item)=> {
            new Swiper(item, {
                loop: false,
                effect: "fade",
                rewind: true,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-gal-next",
                    prevEl: ".sw-gal-prev",
                }
            });
        });
    }  

    let galleryGridSlider = document.querySelectorAll('.gallery-grid-slider');
    if(galleryGridSlider){
        galleryGridSlider.forEach((item)=> {
            new Swiper(item, {
                loop: false,
                effect: "fade",
                rewind: true,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-gal-next",
                    prevEl: ".sw-gal-prev",
                }
            });
        });
    }

    let amenitiesSlider = document.querySelectorAll('.amenities-slider');
    if(amenitiesSlider){
        amenitiesSlider.forEach((item)=> {
            new Swiper(item, {
                loop: false,
                slidesPerView: 1,
                spaceBetween: 40,
                rewind: true,
                autoHeight: true,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                },
                breakpoints: {
                    769: {
                        slidesPerView: 4,
                        spaceBetween: 50,
                    },
                    600: {
                        slidesPerView: 3,
                        spaceBetween: 40,
                    }
                }
            });
        });
    }

    let collaborationsSliders = document.querySelectorAll('.collaborations-sliders');
    if(collaborationsSliders){
        collaborationsSliders.forEach((item)=> {
            new Swiper(item, {
                loop: false,
                slidesPerView: 2,
                spaceBetween: 40,
                rewind: true,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                },
                breakpoints: {
                    769: {
                        slidesPerView: 3,
                    }
                }
            });
        });
    }

    let highlightsSlider = document.querySelectorAll('.highlights-slider');
    if(highlightsSlider){
        highlightsSlider.forEach((item)=> {
            new Swiper(item, {
                loop: true,
                effect: "fade",
                uniqueNavElements: false,
                autoHeight: true,
                fadeEffect: {
                    "crossFade": true
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                    renderBullet: function (index, className) {
                    return '<span class="' + className + '">' + (index + 1) + "</span>";
                    },
                },
                breakpoints: {
                    600: {
                        autoHeight: false,
                    }
                }
            });
        });
    }

});